var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgThickCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 12,
  fill: "none",
  viewBox: "0 0 15 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  fillRule: "evenodd",
  d: "M14.413.918a1 1 0 0 1 .085 1.412l-7.68 8.667a1 1 0 0 1-1.418.079l-4.32-3.9A1 1 0 0 1 2.42 5.69l3.571 3.224 7.01-7.911a1 1 0 0 1 1.412-.086",
  clipRule: "evenodd"
})));
export { SvgThickCheck as ReactComponent };